// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__105G5","row":"Node_row__2RPZ4","label":"Node_label__30mc9","footer":"Node_footer__3AzVc"};